import { getAuthToken } from './authToken'

/**
 * Get JWT OAuth token for authenticated web services
 * This token can be used for customer service, webviews, and other authenticated integrations
 */
export async function getJwtToken(): Promise<string | null> {
  const authToken = getAuthToken()
  if (!authToken) {
    return null
  }

  try {
    const response = await fetch(`${process.env.EXPO_PUBLIC_API_BASE_URL}/api/v2/jwt_oauth/new`, {
      method: 'GET',
      headers: {
        authorization: authToken,
      },
    })

    if (!response.ok) {
      return null
    }

    const data = await response.json()
    return data?.t || null
  } catch (error) {
    console.error('Failed to get JWT token:', error)
    return null
  }
}
